'use strict';

module.exports = function fileItemDecorator(license, file) {
	if (!license || !file) {
		throw new Error('invalid-args');
	}
	const recycleBin = !!(file.trashTs && file.role === 'owner'),
		teamFile = !recycleBin && !!(license.subAccount && file.owner === license.account),
		myFile = !teamFile && !recycleBin && file.role === 'owner',
		sharedFile = !teamFile && !myFile && !file.trashTs,
		sharableFile = !recycleBin && (myFile || teamFile),
		subTeamSharedFile = (file.listItemContext && file.listItemContext.type === 'subteam'),
		subTeamAllowedActions = (file.listItemContext && file.listItemContext.allowedActions) || [],
		unsharableFile = sharedFile && (!subTeamSharedFile || subTeamAllowedActions.includes('unshare-map')),
		context = {
			recycleBin: recycleBin,
			teamFile: teamFile,
			myFile: myFile,
			sharedFile: sharedFile,
			sharableFile: !!sharableFile,
			unsharableFile: !!unsharableFile
		};
	if (!recycleBin && (teamFile || myFile || sharedFile) && file.tags && file.tags.forEach) {
		file.tags.forEach(tag => context['tag:' + tag] = true);
	}
	file.context = context;
	return file;
};
